module.exports = __webpack_public_path__ + "static/media/ricardo-perez-thumbs.72e80197.svg";